<template>
  <div>
    <template>
      <v-card class="mx-auto">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white black--text " @click="close"> close </v-btn>
        </v-toolbar>
      </v-card>
    </template>
    <v-card>
      <v-container class="fixWidth">
        <v-form ref="formVal" lazy-validation>
          <v-row>
            <v-col cols="12" sm="6" md="4" class="beside-drop-down">
              <v-text-field
                v-model="getSchema.title"
                required
                :rules="
                  generalRules
                    .concat(lengthRules)
                    .concat(specialRules)
                    .concat(noJustNumbers)
                "
              >
                <template v-slot:label>
                  Title<strong style="color: red">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="beside-drop-down">
              <v-text-field v-model="getSchema.description">
                <template v-slot:label> Description </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="getSchema.category"
                persistent-hint
                required
                :items="categoryItems"
                chips
                :item-text="(item) => item.name"
                item-value="name"
                :rules="generalRules"
              >
                <template v-slot:label>
                  Category<strong style="color: red">*</strong>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="getSchema.category == 'Event'">
              <v-autocomplete
                v-model="getSchema.is_personal"
                persistent-hint
                required
                :items="eventItems"
                chips
                :item-text="(item) => item.name"
                item-value="id"
                :rules="getSchema.category == 'Event' ? generalRules : ''"
              >
                <template v-slot:label>
                  Event Type <strong style="color: red">*</strong>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="getSchema.institute_id"
                :items="getInstituteItem"
                :item-text="(item) => item.institute_name_en"
                item-value="id"
                persistent-hint
                chips
                label="Institute Name"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="beside-drop-down">
              <v-text-field
                v-model="getSchema.event_place"
                :rules="lengthRules.concat(noJustNumbers)"
              >
                <template v-slot:label> Event Place </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="beside-drop-down">
              
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="dateRange"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :rules="generalRules"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRange"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="generalRules"
                    clearable
                  >
                    <template v-slot:label
                      >Event Date Range<strong style="color: red">*</strong></template
                    >
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="dateRange"
                  :allowed-dates="allowedDatesStart"
                  no-title
                  scrollable
                  :rules="generalRules"
                  range
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(dateRange); separateDateRange()"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
           
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="getSchema.all_day"
                persistent-hint
                required
                :items="allday"
                chips
                :item-text="(item) => item.name"
                item-value="id"
                :rules="generalRules"
              >
                <template v-slot:label
                  >All Day<strong style="color: red">*</strong></template
                >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="beside-drop-down">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="getSchema.start_time"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :disabled="getSchema.all_day != 0"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="getSchema.start_time"
                    label="Start Time"
                    prepend-icon="mdi-clock"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :disabled="getSchema.all_day != 0"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="getSchema.start_time"
                  no-title
                  scrollable
                  format="ampm"
                  :disabled="getSchema.all_day != 0"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu2 = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu2.save(getSchema.start_time)"
                  >
                    OK
                  </v-btn>
                </v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="beside-drop-down">
              <v-menu
                ref="menu3"
                v-model="menu3"
                :close-on-content-click="false"
                :return-value.sync="getSchema.end_time"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :disabled="getSchema.all_day != 0"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="getSchema.end_time"
                    label="End Time"
                    prepend-icon="mdi-clock"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :disabled="getSchema.all_day != 0"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="getSchema.end_time"
                  no-title
                  scrollable
                  format="ampm"
                  :disabled="getSchema.all_day != 0"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu3 = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu3.save(getSchema.end_time)"
                  >
                    OK
                  </v-btn>
                </v-time-picker>
              </v-menu>
            </v-col>
            <!-- {{getInstituteItem}} -->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="getSchema.status"
                required
                :items="itemstatus"
                chips
                :item-text="(item) => item.name"
                item-value="id"
                :rules="generalRules"
              >
                 <template v-slot:label
                  >Status<strong style="color: red">*</strong></template
                >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="beside-drop-down">
              <v-text-field
                v-model="getSchema.notification_before"
                :rules="numberRules"
              >
                <template v-slot:label> Notification (In Minutes) </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-divider></v-divider>
      <template>
        <div class="text-center" v-if="getLoaderStatus">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </template>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn
            color="primary  white--text"
            @click.stop.prevent="validateBefore()"
            >{{ buttonTitle }}</v-btn
          >
          <span></span>
          <v-btn color="red  white--text" @click="clear">Reset</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
    <!--     </v-dialog> -->
  </div>
</template>

<script>
import validationRules from "../../mixins/validationRules";

export default {
  components: {},
  mixins: [validationRules],
  props: ["dialogStatus", "editedData", "indexEdited"],
  data: () => ({
    loading: false,
    dialog: false,
    progressShow: false,
    menu: false,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    dateRange: [],
    itemstatus: [
      {
        id: "1",
        name: "Active",
      },
      {
        id: "0",
        name: "Inactive",
      },
    ],
    allday: [
      {
        id: "1",
        name: "Yes",
      },
      {
        id: "0",
        name: "No",
      },
    ],
    categoryItems: [
      {
        name: "Academic Calendar",
      },
      {
        name: "Event",
      },
    ],
    eventItems: [
      {
        id: "1",
        name: "Personal Event",
      },
      {
        id: "0",
        name: "Institute Event",
      },
    ],
  }),
  created() {
    this.$store.dispatch("callPublicInstitueData");
  },
  mounted() {},
  watch: {
    dialogStatus(val) {
     //  console.log("val sdsd", val);
      this.dialog = val;
    },
    dialog(val) {
      if (!val) this.close();
    },
  },
  computed: {
    getAcademicCalenderItem() {
      return this.$store.getters.getAcademicCalenderItem;
    },
    getInstituteItem() {
      return this.$store.getters.getInstituteItem;
    },
    getSchema() {
      return this.$store.getters.getAcademicCalenderSchema;
    },

    buttonTitle() {
      return this.indexEdited === -1 ? "Save" : "Update";
    },
    formTitle() {
      return this.indexEdited === -1 ? "Create New Event" : "Edit Event ";
    },
    getLoaderStatus() {
      return this.$store.getters.getLoaderStatus;
    },
    currentDate() {
      let date = new Date();
      date.setHours(0, 0, 0, 0);
      return date;
    },
    currentTime() {
      let time = new Date();
      time = time.getTime();
      return time;
    },
  },
  methods: {
    separateDateRange(){
      if(this.dateRange != []){
        if(this.dateRange.length == 2){
          if(new Date(this.dateRange[0])>new Date(this.dateRange[1])){
            this.getSchema.start_date = this.dateRange[1];
            this.getSchema.end_date = this.dateRange[0];
          }else{
            this.getSchema.start_date = this.dateRange[0];
            this.getSchema.end_date = this.dateRange[1];
          }
        }else{
          this.getSchema.start_date = this.dateRange[0];
          this.getSchema.end_date = this.dateRange[0];
        }
      }
     //  console.log(this.getSchema);
    },
    allowedDatesStart: (val) => {
      return new Date(new Date().toLocaleDateString("en-CA")) <= new Date(val);
    },
    allowedDatesEnd(val) {
      return new Date(this.getSchema.start_date) <= new Date(val);
    },
    validateBefore() {
      let valid = this.$refs.formVal.validate();
      if (valid) {
        this.validationForm();
      }
    },

    save() {
      let self = this;
      let formData = new FormData();
      if (this.getSchema.title) {
        formData.append("title", this.getSchema.title);
      }
      if (this.getSchema.description != undefined) {
        formData.append("description", this.getSchema.description);
      }
      if (this.getSchema.event_place != undefined) {
        formData.append("event_place", this.getSchema.event_place);
      }
      if (this.getSchema.is_personal != undefined) {
        formData.append("is_personal", this.getSchema.is_personal);
      }
      if (this.getSchema.category != undefined) {
        formData.append("category", this.getSchema.category);
      }
      if (this.getSchema.start_date != undefined) {
        formData.append("start_date", this.getSchema.start_date);
      }
      if (this.getSchema.end_date != undefined) {
        formData.append("end_date", this.getSchema.end_date);
      }
     //  console.log("startTime", this.getSchema.start_time);
      if (!this.getSchema.start_time) {
        formData.append("start_time", "00:00");
      } else {
        formData.append("start_time", this.getSchema.start_time);
      }
      if (!this.getSchema.end_time) {
        formData.append("end_time", "23:59");
      } else {
        formData.append("end_time", this.getSchema.end_time);
      }
      if (this.getSchema.all_day != undefined) {
        formData.append("all_day", this.getSchema.all_day);
      }
      if (this.getSchema.status != undefined) {
        formData.append("status", this.getSchema.status);
      }
      if (this.getSchema.notification_before != undefined) {
        formData.append(
          "notification_before",
          this.getSchema.notification_before
        );
      }
      if (this.getSchema.institute_id != undefined) {
        formData.append("institute_id", this.getSchema.institute_id);
      }
      let item = this.getSchema;
      this.$store
        .dispatch("saveAcademicCalenderData", formData)
        .then(function (data) {
         //  console.log("Anoy");
          try {
            self.$emit("callReget", true);
            self.close();
          } catch (ex) {
           //  console.log(ex);
          }
        })
        .catch(function () {});
    },
    edit() {
      let self = this;
      let item = this.getSchema;
      let formData = new FormData();
      if (this.getSchema.title) {
        formData.append("title", this.getSchema.title);
      }
      if (this.getSchema.description) {
        formData.append("description", this.getSchema.description);
      }
      if (this.getSchema.event_place) {
        formData.append("event_place", this.getSchema.event_place);
      }
      if (this.getSchema.is_personal) {
        formData.append("is_personal", this.getSchema.is_personal);
      }
      if (this.getSchema.category) {
        formData.append("category", this.getSchema.category);
      }
      if (this.getSchema.start_date) {
        formData.append("start_date", this.getSchema.start_date);
      }
      if (this.getSchema.end_date) {
        formData.append("end_date", this.getSchema.end_date);
      }
      if (this.getSchema.start_time != undefined) {
        if (this.getSchema.start_time == "" || this.getSchema.all_day == 1) {
          formData.append("start_time", "00:00");
        } else {
          formData.append("start_time", this.getSchema.start_time);
        }
      }
      if (this.getSchema.end_time != undefined) {
       //  console.log(typeof this.getSchema.end_time);
        if (this.getSchema.end_time == "" || this.getSchema.all_day == 1) {
          formData.append("end_time", "23:59");
        } else {
          formData.append("end_time", this.getSchema.end_time);
        }
      }
      if (this.getSchema.all_day) {
        formData.append("all_day", this.getSchema.all_day);
      }
      if (this.getSchema.status) {
        formData.append("status", this.getSchema.status);
      }
      if (this.getSchema.notification_before != undefined) {
        formData.append(
          "notification_before",
          this.getSchema.notification_before
        );
      }
      if (this.getSchema.institute_id != undefined) {
        formData.append("institute_id", this.getSchema.institute_id);
      }
      formData.append("id", this.getSchema.id);
      formData.append("_method", "PUT");
      this.$store
        .dispatch("editAcademicCalenderData", {
          id: this.getSchema.id,
          data: formData,
        })
        .then(function (data) {
          self.close();
          self.$emit("update:loadData", true);
          self.$emit("callReget", false);
        })
        .catch(function (error) {
         //  console.log(error);
        });
      this.$emit("saveText", -1);
    },

    close() {
      this.$store.commit("SET_LOADER", false);
      this.$emit("update:dialogStatus", false);
      setTimeout(() => {
        this.$emit("update:indexEdited", -1);
      }, 300);
      this.clear();
    },

    validationForm() {
      return this.indexEdited === -1 ? this.save() : this.edit();
    },
    clear() {
      this.$refs.formVal.reset();
    },
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.fixWidth {
  width: auto;
}
.beside-drop-down {
  margin-top: 10px;
}
</style>
